<template>
    <p v-if="mspType">{{mspType}} | </p>
</template>

<script>
export default {
    computed: {
        mspType() {
            return window.mspType
        }
    }
}
</script>

<style lang="sass" scoped>
p
    font-weight: 700
    display: inline-block
    margin: 0
</style>